import "./SalesTransactionCard.css";

const STATUS_META = {
  paid: { label: "Paid", color: "#1f9d55", tint: "#edfcf0" },
  returned: { label: "Returned", color: "#a68b00", tint: "#fbf7dc" },
  disputed: { label: "Disputed", color: "#c23a3a", tint: "#ffe8e6" },
};

export const SalesTransactionCard = ({ record, currency }) => {
  const meta = STATUS_META[record.status] || STATUS_META.paid;

  return (
    <div className='sl-txn-card'>
      <div className='sl-txn-card-top'>
        <span className='sl-txn-card-product'>{record.name}</span>
        <span className='sl-txn-card-total'>
          {currency}
          {(record.totalPrice || 0).toLocaleString()}
        </span>
      </div>

      <div className='sl-txn-card-meta'>
        <span>{new Date(record.purchaseDate).toLocaleDateString()}</span>
        <span className='sl-txn-card-dot' />
        <span>{record.customer?.fullName || "—"}</span>
      </div>

      <div className='sl-txn-card-bottom'>
        <span className='sl-txn-card-store'>{record.store?.name || "—"}</span>
        <span className='sl-txn-card-mode'>{record.purchaseMode === "inStore" ? "In-Store" : "Online"}</span>
        <span className='sl-txn-card-status' style={{ color: meta.color, background: meta.tint }}>
          {meta.label === "Paid" ? "Sold" : meta.label}
        </span>
      </div>
    </div>
  );
};
